import * as React from "react";
import { observer } from "mobx-react";
import { DialogRoute, RouteStore } from "bernie-core";
import { UitkDialogContent, UitkFullscreenDialog } from "uitk-react-dialog";
import { ToolbarType, UitkToolbar } from "uitk-react-toolbar";
import { Link as RouterLink } from "react-router-dom";
import CitiCardModalDialogPopUp from "./CitiCardModalDialogPopUp";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { Viewport, ViewMedium, ViewSmall } from "@shared-ui/viewport-context";
import { UitkScrim, UitkScrimType } from "uitk-react-scrim";
import { UitkPrimaryFloatingButton, UitkButtonSize } from "uitk-react-button";
import { Layer } from "bernie-view";
import { formatText } from "bernie-l10n";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";

export interface CitiCardModalDialogProps {
  routeStore: RouteStore;
  items: EditorialModel[];
}

interface CitiCardModalDialogState {
  showDialog: boolean;
}

@observer
class CitiCardModalDialog extends React.Component<CitiCardModalDialogProps, CitiCardModalDialogState> {
  constructor(props: CitiCardModalDialogProps) {
    super(props);
    this.state = { showDialog: false };
  }

  onDismissFullscreen = () => {
    this.props.routeStore.closeDialog();
  };

  render() {
    const { routeStore, items = [] } = this.props;
    const uniqueDialogId4 = "dialog-example-4";
    const { showDialog } = this.state;
    const CONTENT_ID_COUNT = 8;

    if (items.length !== CONTENT_ID_COUNT) {
      return null;
    }

    const applyNowText = formatText("grid3.citiDesktopStickybar.applyNow.text");

    return (
      <div className="uitk-type-center all-t-padding-six all-b-padding-twelve">
        <Viewport>
          <ViewSmall>
            <>
              <DialogRoute id={uniqueDialogId4}>
                <Layer id="fullscreenDialog" onDismiss={this.onDismissFullscreen}>
                  <UitkFullscreenDialog dialogShow={showDialog}>
                    <UitkToolbar
                      action={this.onDismissFullscreen}
                      iconLabel="Close the dialog"
                      key="UitkToolbar"
                      type={ToolbarType.CLOSE}
                    />
                    <UitkDialogContent key="Citi-Card-modal-dialog-content">
                      <p key="Citi-Card-modal-dialog-content-Paragraph">
                        <CitiCardModalDialogPopUp items={items} />
                      </p>
                    </UitkDialogContent>
                  </UitkFullscreenDialog>
                </Layer>
              </DialogRoute>

              <UitkLayoutPosition
                position={{ right: "zero", bottom: "zero", left: "zero", zindex: "layer3" }}
                className="uitk-button-floating-action-fixed"
              >
                <UitkScrim type={UitkScrimType.BUTTON}>
                  <RouterLink
                    to={{
                      pathname: routeStore.pathname,
                      search: routeStore.mergeQueryString(routeStore.search, { pwaDialog: uniqueDialogId4 }),
                    }}
                  >
                    <UitkPrimaryFloatingButton isFullWidth size={UitkButtonSize.LARGE} text={applyNowText} />
                  </RouterLink>
                </UitkScrim>
              </UitkLayoutPosition>
            </>
          </ViewSmall>
          <ViewMedium />
        </Viewport>
      </div>
    );
  }
}

export default CitiCardModalDialog;
